angular.module("tasks_status")

    .controller("TasksStatusEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', '$filter', 'modalService', function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, $filter, modalService) {
        
        //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("TASKS_STATUS_WRITE");
        $rootScope.title = $filter('translate')('tasks_status.title');

        $scope.task_status = {};
        $scope.selectEntityTypes = [{ id: 'events', name: $filter("translate")('entity_types.events') }, { id: 'correspondence', name: $filter("translate")('entity_types.correspondence') }, { id: 'general', name: $filter("translate")('entity_types.general') }];

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('tasks_status.title'), url: "tasks_status.list" },
                { title: $filter('translate')('tasks_status.title_add') },
            ];
             
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('tasks_status.title'), url: "tasks_status.list" },
                { title: $filter('translate')('tasks_status.title_edit') },
            ];

            Restangular.one('TasksStatus', $stateParams.id).get().then(function (result) {
                
                $scope.task_status = result;                
            });
        }               
                                       
            $scope.saveTaskStatus = function () {            
            if (angular.isDefined($scope.task_status.id)) {
                $scope.task_status.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('tasks_status.edit_success'));                        
                        $state.go("tasks_status.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('TasksStatus').post($scope.task_status).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('tasks_status.save_success'));
                        $state.go("tasks_status.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('tasks_status.button_delete'),
                message: $filter('translate')('tasks_status.delete_message') + " " + $scope.task_status.name + "?",
                onAccept: function () {
                    $scope.task_status.remove().then(function () {
                        toastr.success($filter('translate')('tasks_status.deleted_success'));
                        $state.go("tasks_status.list");
                    });
                }
            });
        };        

}])

;

